import type React from 'react';

import { Card, Image, Link, Text } from '@change/ds-core-ui';

import type { NewsAndGuidesListItem } from 'src/app/pages/newsAndGuides/list/pageContext';
import { useItemCard } from 'src/app/pages/newsAndGuides/list/shared/hooks';

type Props = {
	item: NewsAndGuidesListItem;
};

export const BasicCard: React.FC<Props & { ref?: React.RefObject<HTMLAnchorElement | null> }> = ({ item, ref }) => {
	const {
		data: { categoryName, targetUrl, smallPhotoUrl },
	} = useItemCard(item);

	return (
		<Card
			as={Link}
			href={targetUrl}
			className="relative overflow-hidden no-underline **:no-underline"
			elevation
			ref={ref}
		>
			{smallPhotoUrl && (
				<Image
					src={smallPhotoUrl}
					alt=""
					className="absolute inset-0 h-full w-full object-cover opacity-10"
					loading="lazy"
					role="presentation"
				/>
			)}
			<div className="relative z-10 px-4 py-10">
				<Text as="span" fontWeight="bold" size="x-small" className="text-typography-weak uppercase">
					{categoryName}
				</Text>
				<Text as="h2" variant="heading" size="x-small" className="text-typography-strong mt-2 mb-6">
					{item.title}
				</Text>
				<Text as="span" size="x-small" className="text-typography-weak">
					{item.createdAtLocalized}
				</Text>
			</div>
		</Card>
	);
};
